import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router";
import { AuthLayout, FormError, FormNotice } from "@/components/layout/auth-layout";
import { api } from "@/lib/api-client";
import { authErrorMessage } from "./error-message";
import { SetPasswordForm } from "./set-password-form";

/** Landing page of the reset email. All other sessions are signed out by the API. */
export function ResetPasswordPage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";

  const confirm = useMutation({
    mutationFn: (password: string) => api<void>("/auth/password-reset/confirm", { body: { token, password } }),
  });

  return (
    <AuthLayout title={t("auth.resetTitle")}>
      {confirm.isSuccess ? (
        <FormNotice message={t("auth.resetDone")} />
      ) : token ? (
        <SetPasswordForm
          submitLabel={t("auth.resetSubmit")}
          pending={confirm.isPending}
          serverError={authErrorMessage(confirm.error, t)}
          onSubmit={(password) => confirm.mutate(password)}
        />
      ) : (
        <FormError message={t("auth.invalidLink")} />
      )}
      <Link to="/login" className="mt-4 block text-center text-sm text-link underline-offset-4 hover:underline">
        {t("auth.backToSignIn")}
      </Link>
    </AuthLayout>
  );
}
